import DiscountList from '../models/DiscountList';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

export interface DiscountListState extends ApiState {
  discountList?: DiscountList[] 
}

export default requestReducer<DiscountListState>('DISCOUNT_LIST')